import React, { useMemo } from 'react';

import {
  usePositionsGet,
  useShiftTypesByPositionIdGet,
} from '@sbv-clients/data-access-api';
import { Divider, ShiftIcon, Stack, Typography } from '@sbv-clients/ui-shared';

export function useShiftTypeName(shiftTypeId: number, positionId: number) {
  const { data: shiftTypes } = useShiftTypesByPositionIdGet({ positionId });

  return useMemo(
    () =>
      shiftTypes?.data?.data?.find((s) => s.shiftTypeId === shiftTypeId)
        ?.shiftTypeName,
    [shiftTypeId, shiftTypes?.data?.data]
  );
}

export function usePositionName(positionId: number) {
  const { data: positions } = usePositionsGet();

  return useMemo(
    () => positions?.find((p) => p.positionId === positionId)?.positionName,
    [positionId, positions]
  );
}

function usePageStatusDetails(shiftTypeId: number, positionId: number) {
  const positionName = usePositionName(positionId);
  const shiftTypeName = useShiftTypeName(shiftTypeId, positionId);

  return { shiftTypeName, positionName };
}

export function PositionShiftTypeDisplay(props: {
  positionId: number;
  shiftTypeId: number;
}) {
  const { shiftTypeName, positionName } = usePageStatusDetails(
    props.shiftTypeId,
    props.positionId
  );
  return (
    <Stack
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 0.4,
        bgcolor: 'background.paper',
        px: 1,
        py: 0.5,
      }}
      direction={'row'}
      spacing={1}
      alignItems={'center'}
    >
      <Typography
        sx={{ color: 'primary.main' }}
        variant={'caption'}
        fontSize={'small'}
        fontWeight={'bold'}
      >
        {positionName}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <ShiftIcon name={shiftTypeName} customSizes={{ width: 19, height: 19 }} />
    </Stack>
  );
}
